angular.
module("dx.webapp.exam").
directive("dxExamPreview", function examPreviewDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			exam: "=",
			questions: "=",
		},
		templateUrl: "tmpl/exam/exam-preview-directive.html",
		controller: "DxExamPreviewController",
		controllerAs: "vm",
		bindToController: true,
	};
});
